<template>
  <icon-base
    :icon="IconEdit"
    class="cursor-pointer"
    :icon-color="UTIL_COLORS.DEFAULT"
    @click="handleEditClick"
  />

  <scorecard-edit-manual-modal
    v-if="showModal"
    :scorecard="model"
    :close="closeModal"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";

import IconBase from "../ui/IconBase.vue";
import ScorecardEditManualModal from "./ScorecardEditManualModal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";

import type { IScorecard } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<IScorecard>,
    required: true,
  },
});

const showModal = ref(false);

const closeModal = () => {
  showModal.value = false;
};

const handleEditClick = () => {
  showModal.value = true;
};
</script>
